import ShadowWrapper from "components/Common/ShadowWrapper";
import i18n from "src/i18n";
import { useModal } from "src/hooks/useModal";

// 개인정보 수집 및 이용 동의
const InformationAgree = () => {
  const { openPrivacyPolicy } = useModal();
  const htmlContent = `
<!doctype html>
<html lang="ko">
  <head>
    <meta charset="UTF-8" />
    <title>개인정보 수집 및 이용 동의 (필수)</title>
    <style>
      /* 첨부파일의 스타일 시트를 그대로 유지합니다 */
      html, body, div, span, object, iframe, h1, h2, h3, h4, h5, h6, blockquote, pre, abbr, address, cite, code, del, dfn, em, img, ins, kbd, q, samp, small, strong, sub, sup, var, b, i, a, dl, dt, dd, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, figcaption, figure, footer, header, hgroup, menu, nav, section, summary, time, mark, audio, video {
        margin: 0; padding: 0; border: 0; outline: 0; text-decoration: none;
      }
      table { border-collapse: collapse; width: 100%; }
      body { font-family: "Noto Sans KR", Sans-serif; color: #333; }
      h1 { font-size: 24px; text-align: center; padding: 40px 0 20px 0; }
      .summary-box { width: 90%; margin: 0 auto 30px auto; padding: 25px; background-color: #f9f9f9; border: 1px solid #eee; border-radius: 8px; }
      .summary-item { margin-bottom: 15px; }
      .summary-item:last-child { margin-bottom: 0; }
      .summary-title { font-weight: bold; font-size: 15px; margin-bottom: 8px; color: #000; display: block; }
      .summary-content { font-size: 14px; line-height: 1.6; color: #666; list-style: none; }
      .summary-content li { position: relative; padding-left: 12px; }
      .summary-content li::before { content: "•"; position: absolute; left: 0; color: #ccc; }
      .data-tb { width: 90%; margin: 20px auto; overflow-x: auto; }
      .data-tb table, .data-tb th, .data-tb td { border: 1px solid #ececec; font-size: 14px; line-height: 1.6; }
      .data-tb th { padding: 12px 10px; background-color: rgba(185, 185, 185, 0.08); }
      .data-tb td { padding: 15px 20px; font-size: 13px; vertical-align: top; }
      .data-tb table th.color { font-weight: bold; background-color: rgba(61, 219, 135, 0.08); }
      .data-tb table th.color-yellow { font-weight: bold; background-color: rgba(242, 255, 125, 0.08); }
      .highlight { color: #e74c3c; font-weight: bold; }
    </style>
  </head>
  <body>
    <h1>개인정보 수집 및 이용 동의</h1>

    <div class="summary-box">
      <div class="summary-item">
        <span class="summary-title">수집 목적</span>
        <ul class="summary-content" style="color:#3183f5; font-weight:bold;">
          <li>클라우드포탈 회원 가입 및 서비스 계약 이행, 계정(ID/PW) 발급 및 연동 처리, 요금 결제·정산 및 청구서 발송, 고객 상담 및 민원 처리, 주요 공지사항 전달</li>
        </ul>
      </div>
      <div class="summary-item">
        <span class="summary-title">수집 항목</span>
        <ul class="summary-content">
          <li>ID, 비밀번호, 성명, 소속 회사명, 부서명, 직급, 회사 이메일 주소, 휴대전화 번호, 유료 결제 시 결제 정보(신용카드 정보 등), 서비스 이용 기록(로그), 접속 IP, 쿠키</li>
        </ul>
      </div>
      <div class="summary-item">
        <span class="summary-title">보유 및 이용 기간</span>
        <ul class="summary-content" style="color:#3183f5; font-weight:bold;">
          <li>회원 탈퇴(계약 종료) 시까지</li>
        </ul>
      </div>
      <p class="summary-content">
      귀하는 위 개인정보 수집 및 이용에 대한 동의를 거부할 권리가 있습니다.<br/>
      단, 동의를 거부하실 경우 클라우드포탈 회원가입 및 일부 서비스 이용이 불가능합니다.</p>
      <div style="margin-top: 20px; padding-top: 15px; border-top: 1px dashed #ddd; text-align: right;">
        <a id="privacy-policy-link" style="color: #e74c3c; font-weight: bold; text-decoration: underline; cursor: pointer;">
          개인정보 처리방침 전문 보기 >
        </a>
      </div>
    </div>

    
  </body>
</html>`;

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    // shadow DOM 내부에 있는 엘리먼트 클릭을 감지하기 위해 composedPath 사용
    const path = e.nativeEvent.composedPath() as HTMLElement[];
    const isLinkClick = path.some((el) => el.id === "privacy-policy-link");

    if (isLinkClick) {
      openPrivacyPolicy();
    }
  };

  return (
    <div style={{ fontFamily: "Noto Sans KR" }} onClick={handleClick}>
      <ShadowWrapper htmlContent={htmlContent} />
    </div>
  );
};

export default InformationAgree;